import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import TableCollapsedContentDetail from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContentDetail';
import useStyles from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContentDetails/TableCollapsedContentDetails.styles';
import { CollapsedContentFrameDetail } from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContentDetails/utils/collapsedContentFrameDetails';
import { getValidFrameDetails } from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContentDetails/utils/getValidFrameDetails';
import { Frame } from 'features/Frames/types';

type TableCollapsedContentProps = {
  frame: Frame;
};

const TableCollapsedContentDetails = ({ frame }: TableCollapsedContentProps) => {
  const validCollapsedContentFrameDetails: CollapsedContentFrameDetail[] =
    getValidFrameDetails(frame);
  const classes = useStyles({ frameDetailsCount: validCollapsedContentFrameDetails.length });

  const frameDetails = validCollapsedContentFrameDetails.map((detail) => (
    <TableCollapsedContentDetail frame={frame} detail={detail} />
  ));

  return (
    <div className={classes.container}>
      {frameDetails.length > 0 ? frameDetails : <Typography>No details available</Typography>}
    </div>
  );
};

export default TableCollapsedContentDetails;
